
import React from 'react';
import { connect } from 'react-redux';
import * as ConfigTypes from 'config/ConfigTypes';
import { withRouter } from 'helpers/ModuleHelper';
import { injectIntl } from 'react-intl';
import { Flow } from 'flow-react';
import { observer } from 'mobx-react';
import { getRentalFields } from "helpers/CartHelper";
import ListItem from "components/Cart/ListItem/ListItem";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCartShopping } from "@fortawesome/free-solid-svg-icons";
import * as actions from 'store/actions';

import './RentalList.scss';

const RentalList = observer(
    class RentalList extends React.Component {
        constructor(props) {
            super(props);
            this.state = {}
        }

        getHeaderClasses = (configName) => {
            if (configName === ConfigTypes.ITEM) {
                return "rentallist-header-items";
            }
            return "rentallist-header";
        }

        onListItemClick = (item) => {
            const { wpView } = this.props.mediaObjects;
            this.props.updateMediaObjects({
                currentClip: item,
                wpView: ConfigTypes.ITEM_DETAIL,
                viewMode: ConfigTypes.ITEM_DETAIL,
                toTop: true,
                lastView: wpView
            });
            this.props.onCloseModal();
            this.props.router.navigate(`${ConfigTypes.ITEM_PATH}/${item.id}`);
        }

        onOtherActions = ({ item, action }) => {
            const { itemsRentalList } = this.props.cartObjects;
            let newItems = [...itemsRentalList];
            // if (action && action === ConfigTypes.DELETE) {
            //     newItems = itemsRentalList.filter(li => li.id !== item.id);
            //     this.props.updateCartObjects({ itemsRentalList: newItems });
            // }

            console.log("LOGS: onOtherActions action", action);
            switch (action) {
                case ConfigTypes.DELETE:
                    newItems = itemsRentalList.filter(li => li.id !== item.id);
                    this.props.updateCartObjects({ itemsRentalList: newItems });
                    break;
                case ConfigTypes.EDIT:
                    this.props.updateCartObjects({ shopForm: ConfigTypes.RENT_EDIT });
                    break;
                default:
                    break;
            }
        }

        isEmpty = () => {
            const { itemsRentalList } = this.props.cartObjects;
            if (itemsRentalList.length === 0) return true;
            return false;
        }

        getShowFields = () => {
            const { rentalFields } = getRentalFields({ props: this.props });
            let fi = `${ConfigTypes.ONLY_CART}`;
            let showFields = rentalFields.map(item => ({ ...item, field: [`${fi}${item.field}`] }));
            return showFields;
        }

        showItemsRentalList = () => {
            const { itemsRentalList } = this.props.cartObjects;
            let showFields = this.getShowFields();
            console.log("LOGS: RentalList showFields", showFields);
            return (
                <div>
                    <div className={this.getHeaderClasses(ConfigTypes.ITEM)}>
                        {showFields.map(item => (
                            <div className={item.htmlClasses && item.htmlClasses}>
                                {item.intl && this.props.intl.formatMessage({ id: item.intl })}
                            </div>))}
                    </div>
                    <ul className="rentallist-body">
                        {itemsRentalList && itemsRentalList.map((item, i) => (
                            <ListItem key={`rentallistCard_${i}`} actions={ConfigTypes.RENTALLIST_ITEMS_ACTIONS}
                                item={item} curMode={ConfigTypes.RENTALLIST} configName={ConfigTypes.ITEM}
                                onOtherActions={this.onOtherActions} showFields={showFields}
                                formatMessage={this.props.intl.formatMessage} isRentalList={true}
                                onListItemClick={this.onListItemClick} cartObjects={this.props.cartObjects} />)
                        )}
                    </ul>
                </div>)
        }

        showFormTitle = () => {
            return (
                <h1 className="rentallist-title">
                    <span><FontAwesomeIcon icon={faCartShopping} /></span>
                    {this.props.intl.formatMessage({ id: "rentallist.heading" })}
                </h1>
            )
        }

        showFormInfo = () => {
            return (
                <div className="rentallist rentallist-infoxbox">
                    <div>
                        {this.showFormTitle()}
                        <p className="rentallist-info">
                            {this.props.intl.formatMessage({ id: "rentellist.emptyinfo" })}
                        </p>
                    </div>
                </div>
            )
        }

        componentDidMount() {
            this.props.getFeRents();
        }

        render() {
            return (
                <div className="rentallist">
                    {(!this.state.loading) && (
                        <div>
                            {this.showFormTitle()}
                            {this.showItemsRentalList()}
                        </div>
                    )}
                </div>
            )
        }
    }
)

const mapStateToProps = (state) => ({
    mediaObjects: state.media.mediaObjects,
    configObjects: state.config.configObjects,
    cartObjects: state.cart.cartObjects,
});

const mapDispatchToProps = (dispatch) => ({
    updateCartObjects: (obj) => dispatch(actions.updateCartObjects(obj)),
    updateMediaObjects: (obj) => dispatch(actions.updateMediaObjects(obj)),
    getFeRents: () => dispatch(actions.getFeRents())
})

export default Flow.injectFlow(connect(mapStateToProps, mapDispatchToProps)(injectIntl(withRouter(RentalList))));